/* MERA MERAH - v8.5 - responsive inventory relocation for mobile layout. */
(function(){
  var TIERS_CONFIG={AT:{S:8000,V:490}};
  var BIN_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1.5 14a2 2 0 0 1-2 2H8.5a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>';
  function getCountry(){try{if(window.Shopify&&Shopify.country)return String(Shopify.country).toUpperCase();}catch(e){}return null;}
  function formatEUR(cents){return '€'+(cents/100).toFixed(2).replace('.',',');}
  function formatEURWhole(cents){var v=cents/100;return '€'+(v===Math.floor(v)?v:v.toFixed(2).replace('.',','));}
  function isDE(){return (document.documentElement.lang||'').toLowerCase().indexOf('de')===0;}
  function isMobile(){return window.innerWidth<=767;}
  function computeTier(cartCents,S,V){
    if(cartCents>=S)return{free:true,currentCost:0,savings:V,nextCost:0,remainingToNext:0,tierIdx:5,remainingToGoal:0};
    var costs=[V,Math.round(V*0.8),Math.round(V*0.6),Math.round(V*0.4),Math.round(V*0.2),0];
    var ratio=cartCents/S;
    var idx=Math.min(4,Math.floor(ratio*5));
    var nextTierStart=Math.round((idx+1)*0.2*S);
    return{free:false,currentCost:costs[idx],nextCost:costs[idx+1],remainingToNext:Math.max(0,nextTierStart-cartCents),tierIdx:idx,savings:V-costs[idx],remainingToGoal:S-cartCents};
  }
  var cartCache=null;var cartCacheAt=0;
  function getCart(cb){var now=Date.now();if(cartCache&&(now-cartCacheAt<800)){cb(cartCache);return;}fetch('/cart.js').then(function(r){return r.json();}).then(function(d){cartCache=d;cartCacheAt=Date.now();cb(d);}).catch(function(){cb(null);});}
  function requiresShipping(cart){if(!cart||!cart.items||!cart.items.length)return false;for(var i=0;i<cart.items.length;i++){if(cart.items[i].requires_shipping)return true;}return false;}
  var isUpdating=false;
  function positionDots(barEl){
    var rect=barEl.getBoundingClientRect();
    var W=rect.width;
    if(!W)return;
    var DOT_W=8;
    var GAP=(W-4*DOT_W)/5;
    var container=barEl.querySelector('.mm-tier-ticks');
    if(!container){
      container=document.createElement('div');container.className='mm-tier-ticks';barEl.appendChild(container);
      for(var i=0;i<4;i++){var d=document.createElement('div');d.className='mm-tier-dot';d.setAttribute('data-idx',i);container.appendChild(d);}
    }
    var dots=container.querySelectorAll('.mm-tier-dot');
    for(var j=0;j<dots.length;j++){
      var centerPx=GAP+DOT_W/2+j*(GAP+DOT_W);
      dots[j].style.left=(centerPx/W*100)+'%';
    }
  }
  function updateBars(){
    if(isUpdating)return;
    isUpdating=true;
    try{
      var country=getCountry();
      var config=TIERS_CONFIG[country];
      if(!config){isUpdating=false;return;}
      var bars=document.querySelectorAll('.free-shipping-bar');
      for(var i=0;i<bars.length;i++){
        var bar=bars[i];
        var cartCents=parseInt(bar.getAttribute('data-free-shipping-current-cart'))||0;
        var S=parseInt(bar.getAttribute('data-free-shipping-amount'))||config.S;
        var V=config.V;
        var stateKey=cartCents+':'+S+':'+V;
        if(bar.__mmState===stateKey)continue;
        bar.__mmState=stateKey;
        bar.classList.add('mm-tier-bar');
        var tier=computeTier(cartCents,S,V);
        var msgNo=bar.querySelector('.free-shipping-bar__message--no');
        if(msgNo&&!tier.free){
          var de=isDE();
          var text=(de?'Kostenloser Versand ab ':'Free shipping from ')+'<strong>'+formatEURWhole(S)+'</strong>';
          text+=' &nbsp; ';
          text+=(de?'noch ':'still ')+'<strong>'+formatEURWhole(tier.remainingToGoal)+'</strong>'+(de?' zum Ziel':' to go');
          if(msgNo.innerHTML!==text)msgNo.innerHTML=text;
        }
        var barEl=bar.querySelector('.free-shipping-bar__bar');
        if(barEl){
          positionDots(barEl);
          var dots=barEl.querySelectorAll('.mm-tier-dot');
          for(var k=0;k<dots.length;k++){
            var boundary=S*(k+1)/5;
            var reached=cartCents>=boundary;
            if(reached)dots[k].classList.add('mm-tier-dot--reached');
            else dots[k].classList.remove('mm-tier-dot--reached');
          }
        }
      }
    }finally{isUpdating=false;}
  }
  function updateTotalsBreakdown(){
    var country=getCountry();
    var config=TIERS_CONFIG[country];
    if(!config)return;
    getCart(function(cart){
      if(!cart||!requiresShipping(cart))return;
      var cartCents=cart.total_price;
      var tier=computeTier(cartCents,config.S,config.V);
      var shippingCents=tier.free?0:tier.currentCost;
      var totalCents=cartCents+shippingCents;
      var de=isDE();
      var LABEL_SUBTOTAL=de?'Zwischensumme':'Subtotal';
      var LABEL_SHIPPING=de?'Versand':'Shipping';
      var LABEL_TOTAL=de?'Gesamt':'Total';
      var LABEL_SAVED=de?'gespart':'saved';
      var LABEL_FREE=de?'KOSTENLOS':'FREE';
      var subs=document.querySelectorAll('.subtotal.h2, h2.subtotal');
      for(var i=0;i<subs.length;i++){
        var sub=subs[i];
        var container=sub.parentElement;
        if(!container)continue;
        var oldBreakdown=container.querySelector('.mm-cart-breakdown');
        if(oldBreakdown)oldBreakdown.remove();
        sub.classList.add('mm-hide-native-subtotal');
        var subtotalMoney=sub.querySelector('.theme-money')?sub.querySelector('.theme-money').textContent.trim():formatEUR(cartCents);
        var savedBadge=(!tier.free&&tier.savings>0)?('<span class="mm-cart-saved">−'+formatEUR(tier.savings)+' '+LABEL_SAVED+'</span>'):'';
        var shipPrice=tier.free?('<strong class="mm-cart-shipping-free">'+LABEL_FREE+'</strong>'):formatEUR(shippingCents);
        var breakdown=document.createElement('div');
        breakdown.className='mm-cart-breakdown';
        breakdown.innerHTML='<div class="mm-cart-row mm-cart-row--sub"><span class="mm-cart-label-wrap"><span class="mm-cart-label">'+LABEL_SUBTOTAL+':</span></span><span class="mm-cart-val">'+subtotalMoney+'</span></div><div class="mm-cart-row mm-cart-row--ship"><span class="mm-cart-label-wrap"><span class="mm-cart-label">'+LABEL_SHIPPING+':</span>'+savedBadge+'</span><span class="mm-cart-val">'+shipPrice+'</span></div><div class="mm-cart-row mm-cart-row--total"><span class="mm-cart-label-wrap"><span class="mm-cart-label">'+LABEL_TOTAL+':</span></span><span class="mm-cart-val">'+formatEUR(totalCents)+'</span></div>';
        sub.after(breakdown);
        var policy=container.querySelector('.cart-policies');
        if(policy)policy.style.display='none';
      }
    });
  }
  function replaceDeleteLinks(){
    var links=document.querySelectorAll('.cart-item__remove, .cart-item .cart-item__remove-link, .cart-item__remove-button');
    for(var i=0;i<links.length;i++){
      var a=links[i];
      if(a.classList.contains('quantity-down')||a.classList.contains('quantity-up'))continue;
      if(a.__mmBin)continue;
      a.__mmBin=true;
      a.classList.add('mm-bin-btn');
      a.setAttribute('title',isDE()?'Aus Warenkorb entfernen':'Remove from cart');
      a.setAttribute('aria-label',isDE()?'Aus Warenkorb entfernen':'Remove from cart');
      a.innerHTML=BIN_SVG;
    }
    var oldBins=document.querySelectorAll('a.quantity-down.mm-bin-btn');
    for(var j=0;j<oldBins.length;j++){
      var d=oldBins[j];d.classList.remove('mm-bin-btn');d.__mmBin=false;d.innerHTML='–';d.setAttribute('aria-label',isDE()?'Menge verringern':'Decrease quantity');
    }
  }
  function relocateInventoryForViewport(){
    var items=document.querySelectorAll('.cart-item');
    var mobile=isMobile();
    for(var i=0;i<items.length;i++){
      var item=items[i];
      var inv=item.querySelector('.product-inventory');
      if(!inv)continue;
      var notImage=item.querySelector('.cart-item__not-image');
      var origParent=item.querySelector('.cart-item__description .very-lightly-spaced-row');
      if(mobile){
        if(inv.parentElement!==notImage){
          if(!inv.dataset.mmOriginalParent&&inv.parentElement){
            inv.dataset.mmOriginalParent='very-lightly-spaced-row';
          }
          inv.classList.add('mm-inv-relocated');
          var qty=item.querySelector('.cart-item__quantity');
          var total=item.querySelector('.cart-item__total');
          if(notImage&&qty&&qty.nextSibling){
            notImage.insertBefore(inv,total||null);
          }else if(notImage){
            notImage.appendChild(inv);
          }
        }
      }else{
        if(inv.classList.contains('mm-inv-relocated')&&origParent&&inv.parentElement!==origParent){
          origParent.appendChild(inv);
          inv.classList.remove('mm-inv-relocated');
        }
      }
    }
  }
  function updateInventoryAndQuantityUI(){
    relocateInventoryForViewport();
    var items=document.querySelectorAll('.cart-item');
    for(var i=0;i<items.length;i++){
      var item=items[i];
      var qtyInput=item.querySelector('input[name="updates[]"], input[type="number"].cart-item__quantity-input, input.cart-item__quantity-input');
      var qtyContainer=item.querySelector('.cart-item__quantity');
      var inv=item.querySelector('.product-inventory');
      if(qtyInput){
        if(!qtyInput.__mmListen){
          qtyInput.__mmListen=true;
          qtyInput.addEventListener('change',function(){setTimeout(updateInventoryAndQuantityUI,50);});
          qtyInput.addEventListener('input',function(){setTimeout(updateInventoryAndQuantityUI,50);});
        }
        var qty=parseInt(qtyInput.value)||1;
        var totalInv=parseInt(qtyInput.getAttribute('max'));
        if(qtyContainer){
          if(qty<=1)qtyContainer.classList.add('mm-qty-min');
          else qtyContainer.classList.remove('mm-qty-min');
        }
        if(inv&&!isNaN(totalInv)){
          var remaining=Math.max(0,totalInv-qty);
          var isDE_=isDE();
          var newTxt=remaining+(isDE_?' auf Lager':' in stock');
          if(inv.textContent.trim()!==newTxt)inv.textContent=newTxt;
          if(remaining<=3){inv.classList.add('mm-stock-urgent');inv.classList.remove('mm-stock-normal');}
          else{inv.classList.add('mm-stock-normal');inv.classList.remove('mm-stock-urgent');}
        }
      }
    }
  }
  function attachObservers(){
    var bars=document.querySelectorAll('.free-shipping-bar');
    for(var i=0;i<bars.length;i++){
      var bar=bars[i];
      if(bar.__mmObs)continue;
      bar.__mmObs=true;
      try{var mo=new MutationObserver(function(){setTimeout(function(){updateBars();updateTotalsBreakdown();replaceDeleteLinks();updateInventoryAndQuantityUI();},50);});mo.observe(bar,{attributes:true,attributeFilter:['data-free-shipping-current-cart']});}catch(e){}
    }
  }
  var origFetch=window.fetch;
  if(origFetch){
    window.fetch=function(){
      var url=arguments[0];
      var pr=origFetch.apply(this,arguments);
      if(typeof url==='string'&&(url.indexOf('/cart/')>-1||url.indexOf('/cart.js')>-1||url.indexOf('/cart?')>-1)){
        pr.then(function(){cartCache=null;setTimeout(function(){updateBars();updateTotalsBreakdown();replaceDeleteLinks();updateInventoryAndQuantityUI();},80);});
      }
      return pr;
    };
  }
  function init(){updateBars();updateTotalsBreakdown();replaceDeleteLinks();updateInventoryAndQuantityUI();attachObservers();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  window.addEventListener('load',function(){setTimeout(init,100);});
  setTimeout(init,500);
  setTimeout(init,2000);
  window.addEventListener('resize',function(){setTimeout(function(){var bars=document.querySelectorAll('.free-shipping-bar__bar');for(var i=0;i<bars.length;i++)positionDots(bars[i]);updateInventoryAndQuantityUI();},80);});
  try{var bodyMo=new MutationObserver(function(){replaceDeleteLinks();updateInventoryAndQuantityUI();});bodyMo.observe(document.body,{childList:true,subtree:true});}catch(e){}
})();